import React from 'react'
import { QuizQuestionWrapper } from '../../QuizQuestionWrapper'
import { useNewPlanningStage, quizTakerRolesNew, plannerStatusesNew } from './NewPlanningStage.hook'
import { NEW_STAGES, QuizType } from 'src/pages/shared'
import { RadioWithIcon } from 'src/common/components/input/RadioWithIcon'
import { Radio } from 'src/common/components'
import { ReactComponent as BouquetIcon } from 'src/assets/icons/bouquet-icon.svg'
import { ReactComponent as CompareItemsIcon } from 'src/assets/icons/compare-items-icon.svg'
import { ReactComponent as BinocularsIcon } from 'src/assets/icons/binoculars-icon.svg'
import './NewPlanningStage.scss'
import { useLocation } from 'react-router-dom'

const disabledDays = new Date()
disabledDays.setDate(disabledDays.getDate() + 1)

const decodeIcon = (value: string) => {
  switch (value) {
    case 'browsing':
      return <BinocularsIcon />
    case 'vendor_selection':
      return <CompareItemsIcon />
    case 'ready_to_buy':
      return <BouquetIcon />
  }
}

export const NewPlanningStage = () => {
  const query = new URLSearchParams(useLocation().search)
  const isPinterestFlow = query.get('quizType') === QuizType.PINTEREST
  const {
    handleBack,
    stage,
    role,
    plannerStatus,
    handleChangeStage,
    handleClickStage,
    handleChangeRole,
    handleChangePlannerStatus,
  } = useNewPlanningStage(query.get('quizType') as QuizType)

  return (
    <>
      <QuizQuestionWrapper
        titleStep="PLANNING"
        title="Where are you in your floral planning?"
        nextAction={{
          disabled: true,
        }}
        backAction={{
          onAction: handleBack,
        }}
        customCss={{
          title: 'title-bold',
          content: 'new-planning-stage-wrapper',
        }}
        step={4}
        total={7}
        className={isPinterestFlow ? 'pinterest-flow planning-stage' : ''}
        quizType={query.get('quizType') as QuizType}
      >
        <div className="new-planning-stage-section">
          {NEW_STAGES.map((item) => (
            <RadioWithIcon
              key={item.value}
              id={item.value}
              value={item.value}
              name="planning"
              classNames={{ container: '', label: 'basic' }}
              checked={stage === item.value}
              onChange={handleChangeStage}
              onClick={() => handleClickStage(item.value)}
            >
              <div className="radio-with-icon-content">
                <div className="icon">{decodeIcon(item.value)}</div>
                <div className="item-label">{item.label}</div>
              </div>
            </RadioWithIcon>
          ))}
        </div>
        {stage && (
          <div className="new-planning-stage-role-section">
            <div className="quiz-question-header">Who is taking this quiz?</div>
            <div className="stage-wrapper">
              {quizTakerRolesNew.map((item) => (
                <Radio
                  key={item.value}
                  id={`new-role-${item.value}`}
                  value={item.value}
                  name="newQuizTakerRole"
                  classNames={{ container: '', label: 'basic' }}
                  checked={role === item.value}
                  onChange={handleChangeRole}
                >
                  {item.label}
                </Radio>
              ))}
            </div>
          </div>
        )}
        {role === 'PLANNER' && (
          <div className="new-planning-stage-role-section">
            <div className="quiz-question-header">What is your status with this client?</div>
            <div className="stage-wrapper">
              {plannerStatusesNew.map((item) => (
                <Radio
                  key={item.value}
                  id={`new-plannerStatus-${item.value}`}
                  value={item.value}
                  name="newPlannerStatus"
                  classNames={{ container: '', label: 'basic' }}
                  checked={plannerStatus === item.value}
                  onChange={handleChangePlannerStatus}
                >
                  {item.label}
                </Radio>
              ))}
            </div>
          </div>
        )}
      </QuizQuestionWrapper>
    </>
  )
}
